import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BrainIcon, DiamondIcon, StoreIcon, SparkleIcon } from './Icons';
const benefits = [{
  icon: <BrainIcon className="w-8 h-8 text-gold" data-id="element-103" />,
  title: 'Paz Mental Instantánea',
  description: 'Aprenderás la técnica de nudos rítmicos que reduce los niveles de cortisol en minutos.'
}, {
  icon: <DiamondIcon className="w-8 h-8 text-gold" data-id="element-104" />,
  title: 'Dominio Técnico de Lujo',
  description: 'Del nudo alondra a tu primer tapiz profesional sin frustraciones.'
}, {
  icon: <StoreIcon className="w-8 h-8 text-gold" data-id="element-105" />,
  title: 'Tu Propio Negocio con Alma',
  description: 'La guía paso a paso para ponerle precio a tu arte y venderlo en mercados de alta gama.'
}, {
  icon: <SparkleIcon className="w-8 h-8 text-gold" data-id="element-106" />,
  title: 'Recuperación de Identidad',
  description: "Deja de ser 'la persona con el problema' para convertirte en una Creadora Consciente."
}];
export const OfferSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-12 md:py-24 px-4 md:px-6 bg-brown text-cream" ref={ref} data-id="element-107">
      <div className="max-w-6xl mx-auto" data-id="element-108">
        <div className="text-center mb-8 md:mb-16" data-id="element-109">
          <h2 className="text-2xl md:text-4xl font-serif mb-3 md:mb-4" data-id="element-110">
            Esto es lo que vas a lograr con el Ebook
          </h2>
          <p className="text-gold font-serif italic text-lg md:text-xl" data-id="element-111">
            "Nudos de Esperanza"
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8" data-id="element-112">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="border border-gold/20 p-5 md:p-8 rounded-sm bg-brown/50 hover:bg-brown/80 transition-colors duration-300 flex flex-col items-start" data-id="element-113">
              <div className="mb-6 p-4 bg-gold/10 rounded-full" data-id="element-114">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-serif font-medium mb-3 text-white" data-id="element-115">
                {benefit.title}
              </h3>
              <p className="text-cream/70 font-light leading-relaxed" data-id="element-116">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};